import React, {FC, useEffect, useRef, useState} from "react";
import {CustomSelectArrow, CustomSelectSelectedDel} from "../../svg";
import {ITextArea as IProps} from "./types";
import cls from '../atoms.module.scss'

const SelectField: FC<IProps> = ({
                                     item,
                                     index,
                                     handleChange,
                                     savedFormData
                                 }) => {
    const [selectedData, setSelectedData] = useState<Array<{ id: number, label: string }>>(
        // @ts-ignore
        [].concat(...item.field_options.map((elemen: { label: string, id: number }) => {
            if (savedFormData && typeof savedFormData[item.attribute_code] === "string") {
                return savedFormData[item.attribute_code].split(",").map((el: string) => {
                    if (elemen.id === +el) {
                        return elemen
                    }
                }).filter(Boolean)
            }
        })).filter(Boolean) || []
    )
    const [open, setOpen] = useState<boolean>(false)
    const rootRef = useRef<{ current: { contains: (arg: EventTarget) => boolean } } | any>(null)

    useEffect(() => {
        const handleEvent = (e: MouseEvent) => {
            if (rootRef.current && !rootRef.current.contains(e.target)) {
                setOpen(false)
            }
        }

        document.addEventListener("mousedown", handleEvent)

        return () => document.removeEventListener('mousedown', handleEvent)
    }, [])
    const handleSelect = (e: { target: { id: string } }) => {
        if (!selectedData.find(el => el.id === +e.target.id)) {
            let newEl = item.field_options.find(
                (el: { id: number }) => el.id === +e.target.id
            )
            if (newEl) {
                setSelectedData([...selectedData, newEl])
                handleChange({
                    target: {
                        name: item.attribute_code,
                        value: [...selectedData.map(item => item.id), newEl.id]
                    }
                }, item.validation)
            }
        }
    }

    const handleDelOption = (e: { target: { id: string } }) => {
        let newArr = selectedData
        newArr.length > 0 && setSelectedData(newArr.filter(
            (el => el.id !== +e.target.id))
        )
        handleChange({
            target: {
                name: item.attribute_code,
                value: newArr.filter((el => el.id !== +e.target.id)).map(item => item.id)
            }
        }, item.validation)
    }

    return <div key={index} className={cls["signUp-position-relative"]}>
        <div className={`${cls["form-group"]} col-12 ${cls["input-paddings"]}`}
             style={{padding: "0px", marginBottom: "0px"}}>
            <div className={`${cls.custom_multiselect} ${open && cls.open}`} ref={rootRef}>
                <div className={cls["custom_multiselect-button"]}>
                    {selectedData.map(el => {
                        return <div
                            key={el?.id}
                            className={cls["custom_multiselect-button_selected"]}
                        >
                            {el?.label}
                            <button className={cls.selected_del_btn}
                                    id={el?.id?.toString()}
                                    onClick={
                                        (e: React.MouseEvent) => handleDelOption(e as unknown as {
                                            target: { id: string }
                                        })
                                    }
                            >
                                <CustomSelectSelectedDel/>
                            </button>
                        </div>
                    })}
                    <CustomSelectArrow className={cls["custom_multiselect-arrow"]} onClick={() => setOpen(!open)}/>
                </div>
                <div className={cls["custom_multiselect-drop_down"]} style={open ? {position: "relative"} : undefined}>
                    {
                        item.field_options.map((el: { id: number, label: string }) => {
                            return <div
                                key={el.id}
                                id={el.id.toString()}
                                className={`${cls["custom_multiselect-option"]}
                            ${selectedData.find(elem => elem?.id === el?.id) ? "selected_option" : ""}
                        `}
                                onClick={
                                    (e) => handleSelect(e as unknown as { target: { id: string } })
                                }
                            >
                                {el.label}
                            </div>
                        })
                    }
                </div>
            </div>
        </div>
    </div>
}

export default SelectField;